import React, { createContext, useContext, useRef } from 'react';

import { MarkdownDndItem } from '@/widgets/conversation-reports-graph/types';

type DndCollectorApi = {
  add: (item: MarkdownDndItem) => void;
  clear: () => void;
  getAll: () => MarkdownDndItem[];
};

const DndCollectorContext = createContext<DndCollectorApi | null>(null);

export const useDndCollector = () => {
  const ctx = useContext(DndCollectorContext);
  if (!ctx) throw new Error('useDndCollector outside provider');
  return ctx;
};

export const DndCollectorProvider = ({ children }: { children: React.ReactNode }) => {
  const ref = useRef<MarkdownDndItem[]>([]);

  const api: DndCollectorApi = {
    add(item) {
      ref.current.push(item);
    },
    clear() {
      ref.current = [];
    },
    getAll() {
      return ref.current;
    },
  };

  return <DndCollectorContext.Provider value={api}>{children}</DndCollectorContext.Provider>;
};
